import styled, { css } from "styled-components";

const labelColor = "#535353"
const iconColor = "#535353"

const borderRadius = "0px"
const inputBorderColorDefault = "#e4e4e4"
const inputBorderColorHover = "#c3c3c3"

const inputHeightMain = "48px"
const inputHeightMainSmall = "35px"
const inputHeightLG = "54px"
const inputHeightLGSmall = "48px"

const marginBottom = 15

const NewFormStyles = styled.div`
    position: relative;
    margin-bottom: ${marginBottom}px;

    // LABEL
    label {
        color: ${labelColor}
    }


    // INPUTS STYLES
    >.input-content {
        position: relative;
    }
    input:not([type="radio"]):not([type="checkbox"]),
    select,
    textarea {
        border-radius: ${borderRadius};
        border: 1px solid ${inputBorderColorDefault};
        padding: 5px 15px;
        color: ${({ theme }) => theme.textBlackMain};
        font-size: 15px;
        transition: .2s;

        &:hover {
            border-color: ${inputBorderColorHover};
        }
        &:focus {
            border-color: #333;
            box-shadow: 0 0 1px 1px #333;
        }
    }

    // HEIGHT
    input:not([type="radio"]):not([type="checkbox"]),
    select {
        height: ${inputHeightMain};

        // ${({ theme }) => theme && css`
        //     @media screen and (max-width: ${theme.responsiveBreakpoints.max_sm}) {
        //         height: ${inputHeightMainSmall};
        //     }
        // `}
    }
    // HEIGHT SIZES WISE
    &.form-lg {
        input:not([type="radio"]):not([type="checkbox"]),
        select {
            height: ${inputHeightLG};
            
            ${({ theme }) => theme && css`
                @media screen and (min-width: ${theme.responsiveBreakpoints.min_sm}) {
                    font-size: 18px;
                }
            `}
            ${({ theme }) => theme && css`
                @media screen and (max-width: ${theme.responsiveBreakpoints.max_sm}) {
                    height: ${inputHeightLGSmall};
                }
            `}
        }
    }

    // LEFT AND RIGHT
    &.form-lt,
    &.form-rt,
    &.form-ct {
        width: 100%;
    }
    ${({ theme }) => theme && css`
        @media screen and (min-width: ${theme.responsiveBreakpoints.min_sm}) {
            &.form-lt,
            &.form-rt {
                width: 50%;
            }

            &.form-lt {
                padding-right: ${marginBottom / 2}px;
            }
            &.form-rt {
                padding-left: ${marginBottom / 2}px;
            }
        }
    `}

    // ICON
    &.has-icon {
        input:not([type="radio"]):not([type="checkbox"]),
        select {
            padding-right: 35px;
        }
        .icon {
            position: absolute;
            top: 50%;
            right: 10px;
            transform: translateY(-50%);
            font-size: 19px;
            color: ${iconColor};
        }

        // ICON SIZES WISE
        &.form-lg {
            input:not([type="radio"]):not([type="checkbox"]),
            select {
                padding-right: 45px;
            }
            .icon {
                font-size: 21px;
            }
        }
    }

    // ERROR MESSAGES
    &.has-error {
        // label {
        //     color: ${({ theme }) => theme.textRed};
        // }

        input:not([type="radio"]):not([type="checkbox"]),
        select,
        textarea {
            border: 1px solid ${({ theme }) => theme.textRed};

            &:focus {
                box-shadow: 0 0 1px 1px ${({ theme }) => theme.textRed};
            }
        }
    }
    .msg-error {
        margin-top: 10px;
        p {
            color: ${({ theme }) => theme.textRed};
            font-size: 13px;
        }
    }
`

export default NewFormStyles